import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ListingModel } from '../../../features/companies/enum/company';
import { CompaniesService } from '../../../features/companies/services/companies.service';
import { ConfigService } from '../../../helpers/config.service';
import { EmployeeService } from '../../../features/companies-users/services/employee.service';

@Component({
  selector: 'app-import-employee-step-one',
  templateUrl: './import-employee-step-one.component.html',
  styles: ``
})
export class ImportEmployeeStepOneComponent implements OnInit {
  SelectedCompanyId!: string;
  SelectedFile: any
  LoadingTemplate: boolean = false;
  Template: any

  loading: boolean = false;
  // companies list variables
  CompaniesListModel = new ListingModel;
  CompaniesList: any[] = [];
  loadingCompanies: boolean = false;
  companiesCount: number = 0;

  company_pageIndex: number = 0;
  company_pageSize: number = 10;

  numberOfRestaurantsFromEndBeforeFetchingMore = this.company_pageSize / 2;

  subscriptions: Subscription[] = []
  constructor(private _dialog: MatDialog,
    private _companyService: CompaniesService,
    private _config: ConfigService,
    public dialogRef: MatDialogRef<ImportEmployeeStepOneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _employeeService: EmployeeService) {

  }
  ngOnInit(): void {
    if (this.data) {
      this.SelectedCompanyId = this.data;
      this.GetTempleat()
    } else {
      this.OnGetCompanies()
    }
  }



  OnGetCompanies() {
    this.loadingCompanies = true;
    this.CompaniesListModel.page = this.company_pageIndex;
    this.CompaniesListModel.perPage = this.company_pageSize;
    let model = { ... this.CompaniesListModel }
    model.page += 1;
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
    this.subscriptions.push(this._companyService.CompaniesSearch(model).subscribe({
      next: (res: any) => {
        this.loadingCompanies = false;
        this.CompaniesList = this.CompaniesList.concat(res.data.list);
        this.companiesCount = res.data.total;
      },
      error: (error: any) => {
        this.loadingCompanies = false;
      }
    }))
  }

  GetTempleat() {
    this.LoadingTemplate = true;
    let model = { company_id: this.SelectedCompanyId }
    this._employeeService.GetTemplateFile(model).subscribe({
      next: (res: any) => {
        this.LoadingTemplate = false;
        this.Template = res
      },
      error: (error: any) => {
        this.LoadingTemplate = false;
      }
    })
  }


  CheckUploadedFile() {
    this.loading = true;
    let model = { company_id: this.SelectedCompanyId, excel_file: this.SelectedFile }
    const formData = new FormData
    formData.append('company_id', model.company_id)
    formData.append('excel_file', model.excel_file)
    this._employeeService.CheckUploadedFile(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.dialogRef.close(res.data);
      },
      error: (error: any) => {
        this.loading = false;
        // Swal.fire({
        //   title: this._config._translate.instant('swalMsg.Failed'),
        //   text: error.errors[0].massage,
        //   icon: 'error',
        //   confirmButtonText: this._config._translate.instant('swalMsg.Ok'),
        // })
      }
    })
  }


  OnSelectFile(files: any) {
    this.SelectedFile = files[0];
  }


  // ng-select companies

  dropSearch(data: any) {
    this.company_pageIndex = 0;
    this.CompaniesList = [];
    this.CompaniesListModel.search = data?.term || '';
    this.OnGetCompanies();
  }


  // Company with Scroll
  onCompaniesScroll({ end }: any) {
    if (this.loadingCompanies || (this.CompaniesList.length <= this.companiesCount)) {
      return;
    }
    if (end + this.numberOfRestaurantsFromEndBeforeFetchingMore >= this.CompaniesList.length) {
      this.company_pageIndex++;
      this.OnGetCompanies();
    }
  }

  onCompaniesScrollToEnd() {
    if (this.CompaniesList.length < this.companiesCount) {
      this.company_pageIndex++;
      this.OnGetCompanies();
    }
  }


}
